import { render, staticRenderFns } from "./medicoPortal.vue?vue&type=template&id=9859961c"
import script from "./medicoPortal.vue?vue&type=script&lang=js"
export * from "./medicoPortal.vue?vue&type=script&lang=js"
import style0 from "./medicoPortal.vue?vue&type=style&index=0&id=9859961c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports